import type { ReactNode } from 'react';
import { cn } from '@/shared/utils';

interface PageContainerProps {
  children: ReactNode;
  className?: string;
  /** Animation preset for page transitions */
  animation?: 'fade' | 'slide-right' | 'none';
}

/**
 * Container for page content with consistent padding and max-width.
 * Matches the prototype design with p-8, max-w-[1600px], and centered content.
 * Uses w-full to ensure consistent width across all pages.
 */
export function PageContainer({ children, className, animation = 'fade' }: PageContainerProps) {
  const animationClasses =
    animation === 'none'
      ? ''
      : animation === 'slide-right'
        ? 'animate-in fade-in slide-in-from-right-4 duration-300'
        : 'animate-in fade-in duration-300';

  return (
    <div className={cn('p-8 w-full max-w-[1600px] mx-auto', animationClasses, className)}>
      {children}
    </div>
  );
}
